import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import AxiosRequest from '../axiosComponent/allAxiosCommonRequest';
//import { GetCommonBaseURL } from '../axiosComponent/read';


const MyPSLineItem = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [contents, setcontents] = useState([])
    const [isloading, setisloading] = useState(true)
    useEffect(() => {
        AxiosRequest({
            url: "masters/psLineItem",
            method: "get",
          })//CommonGetApi({ url: 'branch' })
          .then((data) => {
            setcontents(data.data.resultSet)
                if (props.value !== '' && props.mode == 'vmode') {
                    let price = data.data.resultSet.filter(args => args.psCode == props.value)
                    setFieldValue(props.priceDes, price[0].purchasePrice)
                }
                setisloading(false)
        }).catch((error) => console.log(error))
/*         GetCommonBaseURL({
            newUrl: `masters/psLineItem`, response: ((data) => {
                setcontents(data.data.resultSet)
                if (props.value !== '' && props.mode == 'vmode') {
                    let price = data.data.resultSet.filter(args => args.psCode == props.value)
                    setFieldValue(props.priceDes, price[0].purchasePrice)
                }
                setisloading(false)
            })
        }) */
    }, [])

    let cityNames = []
    if (contents.length > 0) {
        contents.map((object, index) => {
            console.log(object,'pslineitems')
            let temp = {}
            temp.key = object.psId
            temp.text = object.psDescription
            temp.value = props.lrMode ? object.psId : object.psCode
            temp.extra = object
            return cityNames[index] = temp
        })
    }

    // let fit = cityNames.filter((args) => args.value == props.value)
    // // let price = cityNames.find((args) => args.value == props.value).extra
    // if (fit) {
    //     setFieldValue(props.priceDes, fit[0].extra.purchasePrice !== null ? fit[0].extra.purchasePrice : 0)
    // }
    // console.log('PROC', fit)
    let handleChange = (data) => {
        console.log(data,'dataValue')
        setFieldValue(name, data.value)
        let values = data.value
        let id = data.options.find((args) => args.value === values).key
        let extra = data.options.find((args) => args.value === values).extra
        setFieldValue(props.id, id)
        setFieldValue(props.priceDes, extra.purchasePrice !== null ? extra.purchasePrice : 0)
        setFieldValue(props.address, extra.address)
        setFieldValue(props.cityName, extra.cityName !== null ? extra.cityName : '')
        setFieldValue(props.phone, extra.phone !== null ? extra.phone : '')
        setFieldValue(props.pincode, extra.pincode !== null ? extra.pincode : '')
        if (props.advanceMode) {
            // console.log(id)
            AxiosRequest({
                url: '/advSettle/vendorAdvance/advanceGivenForPSItem',
                Items: {
                    advanceId: props.advId,
                    psId: id
                },
                method: 'post',
            }).then((resp) => {
                if (resp.data.data.length > 0) {
                    setFieldValue(props.readAmount, resp.data.data[0].totalPsAmountGiven ? resp.data.data[0].totalPsAmountGiven : 0)
                }
            }).catch((err) => {
                let message = err.response.data.message
                if (message != null) {
                    // NotificationManager.error(message)
                }
            })
        }
    }
    return (
        <Dropdown
            selection
            loading={isloading}
            style={{ width: "100%" }}
            // search
            onChange={(value, data) => handleChange(data)}
            options={cityNames}
            {...props}
        />

    )
}

export default MyPSLineItem